import { render, staticRenderFns } from "./SimpleList.vue?vue&type=template&id=16f66a8c&scoped=true"
import script from "./SimpleList.vue?vue&type=script&lang=js"
export * from "./SimpleList.vue?vue&type=script&lang=js"
import style0 from "./SimpleList.vue?vue&type=style&index=0&id=16f66a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f66a8c",
  null
  
)

export default component.exports